import { module } from 'angular';

import { ColorPickerDirective, default as colorPickerDirectiveName } from './color-picker.directive';

export default module('contact.commons.toolbox.color-picker', []).directive(colorPickerDirectiveName, ColorPickerDirective).name;
